export default [
  {
    name: 'service_key',
    label: 'Integration Key',
    type: 'text',
    required: true,
    helpText: 'Enter the integration key for this service. PagerDuty creates this key when you\'re configuring the service.',
    errorText: 'Integration Key must be 32 alpha-numeric characters.',
  },
];
